export const mailRegexs = {
  siteUrl: "http&#58;//abc.com",
  siteUrl2: "https&#58;//viags.azurewebsites.net/",
  zero: "&#123;0&#125",
  one: "&#123;1&#125",
  two: "&#123;2&#125",
  three: "&#123;3&#125",
  four: "&#123;4&#125",
  five: "&#123;5&#125",
  six: "&#123;6&#125",
  seven: "&#123;7&#125",
  eight: "&#123;8&#125",
  nine: "&#123;9&#125",
  ten: "&#123;10&#125",
};

export const mailRegex = {
  siteUrl: "http&#58;//abc.com",
  zero: "&#123;0&#125;",
  one: "&#123;1&#125;",
  two: "&#123;2&#125;",
  three: "&#123;3&#125;",
  four: "&#123;4&#125",
  five: "&#123;5&#125",
  six: "&#123;6&#125",
  seven: "&#123;7&#125",
  eight: "&#123;8&#125",
  nine: "&#123;9&#125",
  ten: "&#123;10&#125",
};
